import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  DialogContentText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useCreateQaTicketMutation } from "api/memberPortal/qa/qa.api";

interface CreateQaConfirmationModalProps {
  show: boolean;
  handleClose: () => void;
}

const CreateQaConfirmationModal = ({
  show,
  handleClose,
}: CreateQaConfirmationModalProps) => {
  const navigate = useNavigate();
  const [createQaTicket, { isLoading, isError }] = useCreateQaTicketMutation();

  const handleSubmit = async () => {
    const result = await createQaTicket({}).unwrap();

    if (result?.rid) {
      handleClose();
      navigate(`/community/question-answer/details/${result.rid}`);
    }
  };

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      sx={{ "& .MuiDialog-paper": { alignSelf: "flex-start", mt: 8 } }}
    >
      <DialogTitle>Create a New QA?</DialogTitle>

      <DialogContent>
        {isError ? (
          <Alert severity="error" sx={{ mt: 1 }}>
            Error creating new QA
          </Alert>
        ) : (
          <DialogContentText fontStyle="italic">
            You will be redirected to the details page to fill out the content.
          </DialogContentText>
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Cancel
        </Button>

        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={isLoading}
          data-cy="create-qa"
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateQaConfirmationModal;
